import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    if (window.innerWidth < 768) {
      this.element.closest(".dashboard__box").classList.toggle("active")
    }
  }
}
